import { Box, Typography } from "@mui/material";
import { useAppDispatch } from "features/store";
import { logout } from "features/auth/authSlice";
import CustomButton from "components/common/CustomButton";

export default function NotWebUserPage() {
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logout());
    window.location.replace("/login");
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ backgroundColor: "white" }}
    >
      <Box
        marginTop={12}
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          width: "100%",
          maxWidth: 400,
          boxSizing: "border-box",
          px: { xs: 2, sm: 3 },
          bgcolor: "#fff",
          p: { xs: 2, sm: 4 },
          borderRadius: 1.5,
          border: "1px solid #e0e0e0",
        }}
      >
        <Typography
          component="h1"
          variant="h5"
          sx={{ fontSize: "32px" }}
          className="mb-4 whitespace-nowrap text-[rgb(31,93,107)]"
        >
          Access not available
        </Typography>
        <Typography sx={{ mb: 3, color: "text.secondary", textAlign: "center" }}>
          You are not authorized as a Web User. Please contact{" "}
          <Typography
            component="a"
            href="mailto:development@calibratehcm.com"
            sx={{ color: "rgb(31, 93, 107)", "&:hover": { textDecoration: "underline" } }}
          >
            development@calibratehcm.com
          </Typography>{" "}
          for assistance.
        </Typography>
        <CustomButton onClick={handleLogout}>Logout</CustomButton>
      </Box>
    </Box>
  );
}
